export default __webpack_public_path__ + "static/Plots0004-869d92a7b0952eb04256d12a36ddfc59.jpg";